type Props = { url: string | null | undefined };

export function CardPhotoBg({ url }: Props) {
  if (!url) return null;
  // Belt-and-suspenders: card backgrounds must use direct CDN URLs only
  // (SerpAPI). Skip the Google Places proxy path even if a stale row sneaks
  // through — the proxy hits Google's API and is rate-limited / kill-switched.
  if (url.startsWith("/api/photos/proxy")) return null;
  return (
    <img
      src={url}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      className="pointer-events-none absolute inset-0 w-full h-full object-cover opacity-20 blur-[2px] scale-110 -z-10"
      onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = "none"; }}
    />
  );
}
